import { render, staticRenderFns } from "./LinkedRemitterPage.vue?vue&type=template&id=7ada27a5"
import script from "./LinkedRemitterPage.vue?vue&type=script&lang=js"
export * from "./LinkedRemitterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports